import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { CREATE_PARAM } from './actionTypes';
import { createParameterSuccessful, createParametersFailed } from './actions';

// Include call API
import { getParametersAPI } from "../../../api/securityparameters";

const parametersAPI = getParametersAPI();

// Is user create successfull then direct plot user in redux.
function* createPARAM({ payload: { param, history } }) {
    console.log("saga")
    try {
        const response = yield call(parametersAPI.createParameter, param.ip, param.port, param.token);
        yield put(createParameterSuccessful(response.message));
        history.push('/createparameter')
    } catch (error) {
        yield put(createParametersFailed(error));
    }
}

export function* watchPARAMRegister() {
    yield takeEvery(CREATE_PARAM, createPARAM);
}

function* createPARAMSaga() {
    yield all([fork(watchPARAMRegister)]);
}

export default createPARAMSaga;